import * as Sentry from '@sentry/browser';
import { datadogRum } from '@datadog/browser-rum';

import heapHelper from './util/heapHelper';
import tealiumHelper from './util/tealium';
import { AbstractAnalyticsLogger } from './util/analyticsLogger';
import { AdobeLaunch } from './util/adobeLaunch';

const initializeSentry = () => {
  const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

  if (!SENTRY_DSN) { return; }

  try {
    Sentry.init({
      dsn: SENTRY_DSN,
      release: process.env.COMMIT || 'development',
      environment: process.env.TENANT,
    });
  } catch (error) {
    console.log('error initializing sentry');
    console.log(error);
  }
};

const initializeDatadog = () => {
  if (!process.env.REACT_APP_DATADOG_APP_ID || !process.env.REACT_APP_DATADOG_CLIENT_ID) {
    return;
  }

  datadogRum.init({
      applicationId: process.env.REACT_APP_DATADOG_APP_ID,
      clientToken: process.env.REACT_APP_DATADOG_CLIENT_ID,
      site: 'datadoghq.com',
      service: 'customer-dashboard',
      env: process.env.REACT_APP_ENVIRONMENT,
      version: process.env.COMMIT || 'development',
      sessionSampleRate: 10,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input'
  });

  datadogRum.startSessionReplayRecording();
};

initializeSentry();
initializeDatadog();
heapHelper.initializeHeap();

export const analyticsHelper: AbstractAnalyticsLogger =
  AvantConfig.TenantConfig.analytics?.provider === 'adobeLaunch'
    ? new AdobeLaunch()
    : new tealiumHelper();
